const customEnv = process.env.REACT_APP_ENV || "development";

const configs = {
  development: {
    baseURL: "http://localhost:3030/api",
    wsURL: "ws://localhost:3001/ws",
    warehouseBaseURL: "http://localhost:3031/wms",
    omsUrl: "http://localhost:3034/rl-order",
    kaman_expert_copilot: { id: "117_0", name: "Ask Dropskip" },
    kaman_expert_forecast: { id: "145_0", name: "Inventory Forecast" },
    // TODO(user): fill in once this expert is provisioned in Kaman — see
    // ForecastPlannerAgent (planning-forecast's "Custom" drawer).
    kaman_expert_forecast_planner: { id: "", name: "Forecast Planner" },
    kaman_expert_network: { id: "146_0", name: "Network Simulator" },
    kaman_expert_tariff: { id: "135_0", name: "Tariff Triage" },
    kaman_expert_calculator: { id: "137_0", name: "Fully Landed Calculator" },
    kaman_baseUrl: "https://kaman.in/api/agent",
  },
  test: {
    baseURL: "https://rl.yoctotta.com/api",
    wsURL: "wss://rl.yoctotta.com/ws",
    omsUrl: "https://rl.oms.yoctotta.com/rl-order",
    warehouseBaseURL: "https://rl.yoctotta.com/wms",
    kaman_expert_copilot: { id: "117_0", name: "Ask Dropskip" },
    kaman_expert_forecast: { id: "145_0", name: "Inventory Forecast" },
    kaman_expert_forecast_planner: { id: "", name: "Forecast Planner" },
    kaman_expert_network: { id: "146_0", name: "Network Simulator" },
    kaman_expert_tariff: { id: "135_0", name: "Tariff Triage" },
    kaman_expert_calculator: { id: "371_0", name: "Fully Landed Calculator" },
    kaman_baseUrl: "https://kaman.in/api/agent",
  },
  uat: {
    baseURL: "https://uat.dropskip.app/api",
    wsURL: "wss://uat.dropskip.app/ws",
    omsUrl: "https://uat.oms.dropskip.app/rl-order",
    warehouseBaseURL: "https://uat.dropskip.app/wms",
    kaman_expert_copilot: { id: "390_0", name: "Ask Dropskip" },
    kaman_expert_forecast: { id: "117_0", name: "Inventory Forecast" },
    kaman_expert_forecast_planner: { id: "1304_0", name: "Forecast Planner" },
    kaman_expert_network: { id: "160_0", name: "Network Simulator" },
    kaman_expert_tariff: { id: "147_0", name: "Tariff Triage" },
    kaman_expert_calculator: { id: "371_0", name: "Fully Landed Calculator" },
    kaman_baseUrl: "https://kaman.ai/api/agent",
  },
  production: {
    baseURL: "https://dropskip.app/api",
    wsURL: "wss://dropskip.app/ws",
    omsUrl: "https://oms.dropskip.app/rl-order",
    warehouseBaseURL: "https://dropskip.app/wms",
    kaman_expert_copilot: { id: "956_0", name: "Ask Dropskip" },
    kaman_expert_forecast: { id: "957_0", name: "Inventory Forecast" },
    kaman_expert_network: { id: "958_0", name: "Network Simulator" },
    kaman_expert_tariff: { id: "959_0", name: "Tariff Triage" },
    kaman_expert_calculator: { id: "961_0", name: "Fully Landed Calculator" },
    kaman_baseUrl: "https://kaman.ai/api/agent",
    kaman_expert_forecast_planner: { id: "1306_0", name: "Forecast Planner" },
  },
};

// Get config based on environment
const config = configs[customEnv];

// Log current environment (remove in production)
console.log(`Running in ${customEnv} environment`);

export default config;
